module.exports = __webpack_public_path__ + "img/Support-skill-131.f5e310b3.png";